// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": true,
    "raw": "2c1175b-dirty",
    "hash": "2c1175b",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "2c1175b-dirty",
    "semverString": null,
    "version": "0.0.1"
};
/* tslint:enable */
